import React from 'react';
import Login from '../views/login/index';
import Home from '../views/home';
import CreateRoute from '../views/createRoute';
import OfflineDevice from '../views/offlineDevice';
import Events from '../views/reports/events';
import Commands from '../views/reports/commands';
import Accesses from '../views/reports/accesses/index';
import Positions from '../views/reports/positions/index';
import Hourmeter from '../views/reports/hourmeter/index';
import ArlugHome from '../views/arlug/index';
import { AuthConsumer } from '../main/authenticationProvider';
import { Route, Switch, HashRouter, Redirect } from 'react-router-dom';
import { MgmtClients } from '../views/mgmt/clients';
import { MgmtLogins } from '../views/mgmt/logins';
import { MgmtPlates } from '../views/mgmt/plates';
import { SettingHorimeter } from '../views/mgmt/settingHorimeter';
import { NotFound } from '../views/notFound';
import { MgmtLoginForm } from '../views/mgmt/logins/form';
import { MgmtClientForm } from '../views/mgmt/clients/form';
import { MgmtPlatesForm } from '../views/mgmt/plates/form/createPlate';
import { MgmtPlatesUpdate } from '../views/mgmt/plates/form/updatePlate';
import MgmtHourmeter from '../views/mgmt/reports/hourmeter';
import MgmtPositions from '../views/mgmt/reports/positions';
import MgmtCommands from '../views/mgmt/reports/commands';
import StatusLink from '../views/statusLinks';
import RouteInitiated from '../views/routeInitiated';

function Rotas(props) {
    let routes = [
        {
            path: "/404",
            component: NotFound
        },
    ];

    if (props.isUserAuthenticated && props.userType === 'client') {
        routes.push(
            {
                key: 0,
                path: "/",
                component: Home
            },
            {
                key: 1,
                path: "/createRoute",
                component: CreateRoute
            },
            {
                key: 2,
                path: "/statusLink",
                component: StatusLink
            },
            {
                key: 3,
                path: "/routeInitiated",
                component: RouteInitiated
            },
            {
                key: 4,
                path: "/offlineDevice",
                component: OfflineDevice
            },
            {
                key: 5,
                path: "/events",
                component: Events
            },
            {
                key: 6,
                path: "/commands",
                component: Commands
            },
            {
                key: 7,
                path: "/accesses",
                component: Accesses
            },
            {
                key: 8,
                path: "/positions",
                component: Positions
            },
            {
                key: 9,
                path: "/hourmeter",
                component: Hourmeter
            },
            {
                key: 10,
                //     path: "/arlug",
                //     component: ArlugHome
                // },
                // {
                //     key: 11,
                path: "/mgmt",
                to: "/",
                redirect: true,
            },
            {
                key: 11,
                path: "*",
                to: "/404",
                redirect: true,
            }
        );
    } else if (props.isUserAuthenticated && props.userType === 'mgmt') {
        routes.push(
            {
                key: 1,
                path: "/mgmt/clients",
                component: MgmtClients
            },
            {
                key: 2,
                path: "/mgmt/client/create",
                component: MgmtClientForm
            },
            {
                key: 3,
                path: "/mgmt/logins",
                component: MgmtLogins
            },
            {
                key: 4,
                path: "/mgmt/login/create",
                component: MgmtLoginForm
            },
            {
                key: 5,
                path: "/mgmt/login/update",
                component: MgmtLoginForm
            },
            {
                key: 6,
                path: "/mgmt/plates",
                component: MgmtPlates
            },
            {
                key: 7,
                path: "/mgmt/plate/create",
                component: MgmtPlatesForm
            },
            {
                key: 8,
                path: "/mgmt/plate/update",
                component: MgmtPlatesUpdate
            },
            {
                key: 9,
                path: "/",
                to: "/mgmt/clients",
                redirect: true,
            },
            {
                key: 10,
                path: "/mgmt/settingHorimeter",
                component: SettingHorimeter,
            },
            {
                key: 13,
                path: "/mgmt/horimeter",
                component: MgmtHourmeter,
            },
            {
                key: 14,
                path: "/mgmt/positions",
                component: MgmtPositions,
            },
            {
                key: 15,
                path: "/mgmt/commands",
                component: MgmtCommands,
            },
            {
                key: 16,
                path: "*",
                to: "/404",
                redirect: true,
            }
        );

    } else if (props.isUserAuthenticated && props.userType === "arlug_client") {
        routes.push(
            {
                key: 0,
                path: "/",
                component: ArlugHome
            },
            {
                key: 9,
                path: "/hourmeter",
                component: Hourmeter
            },
            {
                key: 11,
                path: "*",
                to: "/404",
                redirect: true,
            }
        );
    } else {
        routes.push(
            {
                key: 0,
                path: "/login",
                component: Login,
            },
            {
                key: 1,
                path: "/",
                to: "/login",
                redirect: true,
            },
            {
                key: 2,
                path: "*",
                to: "/login",
                redirect: true,
            }
        );
    }


    return (
        <HashRouter>
            <Switch>
                {routes.map((r, index) =>
                    r.redirect ? (
                        <Redirect
                            key={index}
                            exact
                            from={r.path}
                            to={{
                                pathname: r.to,
                                state: { from: props.location }
                            }}
                        />
                    ) : (
                        <Route key={"route-" + r.path} path={r.path} component={r.component} exact />
                    )
                )}
            </Switch>
        </HashRouter>
    )
}

export default () => (
    <AuthConsumer>
        {(context) => (<Rotas isUserAuthenticated={context.isAuthenticated} userType={context.userType} />)}
    </AuthConsumer>
);